import StarCheckedIcon from '@/assets/icons/StarCheckedIcon';
import WrenchBold from '@/assets/icons/WrenchBold';
import MDRIcon from '@/assets/icons/MDRIcon';
import ProfileBoldIcon from '@/assets/icons/ProfileBoldIcon';
import CircleQuestionBoldIcon from '@/assets/icons/CircleQuestionBoldIcon';
import PrivateSharingMobileIcon from '@/assets/icons/PrivateSharingMobileIcon';
import NotificationsBoldIcon from '@/assets/icons/NotificationsBoldIcon';
import ExitBoldIcon from '@/assets/icons/ExitBoldIcon';
import { isProduction } from '../config';
import ExitIcon from '../assets/icons/Exit';
import ProfileIcon from '../assets/icons/ProfileIcon';
import CircleQuestion from '../assets/icons/CircleQuestion';
import PrivateSharingIcon from '../assets/icons/PrivateSharingIcon';
import Bell from '../assets/icons/Bell';

const getSettingItems = ({
  dashboardLinkPrefix,
  propertyDashboardLinkPrefix,
  isMobile,
  isFromPersonal,
}) => {
  const settings = [
    {
      id: 0,
      title: 'profil og innstillinger',
      items: [
        {
          icon: isMobile
            ? () => ProfileBoldIcon({ fill: '#000' })
            : () => ProfileIcon({ fill: '#111' }),
          text: 'Min profil',
          to: `${dashboardLinkPrefix}/more/account`,
        },
        {
          icon: isMobile ? CircleQuestionBoldIcon : CircleQuestion,
          text: 'Hjelp og kundestøtte',
          to: `https://support.boligmappa.no`,
          isExternalLink: true,
          openInNewTab: true,
        },
        {
          icon: isMobile ? PrivateSharingMobileIcon : PrivateSharingIcon,
          text: 'Del din Boligmappe',
          hideInSharedProperty: true,
          propertyRequired: true,
          to: `${propertyDashboardLinkPrefix}/more/private-share`,
        },
        {
          icon: isMobile ? NotificationsBoldIcon : Bell,
          text: 'Meldinger',
          notificationsBadge: true,
          to: `${propertyDashboardLinkPrefix}/notifications`,
          hideInPersonalArea: true,
        },
      ],
    },
    {
      // required for key list prop in react
      id: 2,
      title: 'Tjenester',
      mobileOnly: true,
      experimental: false,
      items: [
        {
          icon: StarCheckedIcon,
          text: 'Leverandører',
          to: `${propertyDashboardLinkPrefix}/vendors`,
        },
        {
          text: 'Skaff dokumentasjon',
          icon: MDRIcon,
          to: `${propertyDashboardLinkPrefix}/create-mdr`,
        },
        {
          icon: WrenchBold,
          text: 'Finn håndverker',
          to: `${propertyDashboardLinkPrefix}/more/find-professional`,
        },
      ],
    },
    {
      id: 3,
      items: [
        {
          to: '/logout',
          icon: isMobile ? ExitBoldIcon : ExitIcon,
          className: 'logout',
          text: 'Logg ut',
          noBorder: true,
        },
      ],
    },
  ];

  const personalSettings = [
    {
      id: 0,
      items: [
        {
          to: '/logout',
          icon: ExitIcon,
          text: 'Logg ut',
        },
      ],
    },
  ];

  const defaultSettings = settings.filter(({ experimental }) => {
    const isNotInProduction = !isProduction();
    if (isNotInProduction) return true;
    return !experimental;
  });

  const defaultPersonalSettings = personalSettings.filter(
    ({ experimental }) => {
      const isNotInProduction = !isProduction();
      if (isNotInProduction) return true;
      return !experimental;
    }
  );

  if (!isFromPersonal) {
    return defaultSettings;
  }
  return defaultPersonalSettings;
};

export default getSettingItems;
